import script from "./FleetDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./FleetDashboardView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__